/* eslint-disable @typescript-eslint/consistent-type-assertions */
// TODO: reconsider use of type assertions and implement something safer with type guards or similar
import React from 'react';
import type { Activity, ActivityType } from '../../../../common/types.tsx';
import { AssigneeChanged } from '../activity-items/assignee-changed/index.tsx';
import { AttachmentAdded } from '../activity-items/attachment-added/index.tsx';
import { CommentAdded } from '../activity-items/comment-added/index.tsx';
import { IssueCreated } from '../activity-items/issue-created/index.tsx';
import { PriorityChanged } from '../activity-items/priority-changed/index.tsx';
import { SingleFieldUpdated } from '../activity-items/single-field-updated/index.tsx';
import { StatusChanged } from '../activity-items/status-changed/index.tsx';

type ActivityItemProps = {
	activity: Activity<ActivityType>;
};

const renderActivityComponent = (activity: Activity<ActivityType>) => {
	switch (activity.type) {
		case 'ASSIGNEE_CHANGED':
			return <AssigneeChanged activity={activity as Activity<'ASSIGNEE_CHANGED'>} />;
		case 'ATTACHMENT_ADDED':
			return <AttachmentAdded activity={activity as Activity<'ATTACHMENT_ADDED'>} />;
		case 'COMMENT_ADDED':
			return <CommentAdded activity={activity as Activity<'COMMENT_ADDED'>} />;
		case 'CREATED':
			return <IssueCreated activity={activity as Activity<'CREATED'>} />;
		case 'PRIORITY_CHANGED':
			return <PriorityChanged activity={activity as Activity<'PRIORITY_CHANGED'>} />;
		case 'SINGLE_FIELD_UPDATED':
			return <SingleFieldUpdated activity={activity as Activity<'SINGLE_FIELD_UPDATED'>} />;
		case 'STATUS_CHANGED':
			return <StatusChanged activity={activity as Activity<'STATUS_CHANGED'>} />;
		default:
			return null;
	}
};

export const ActivityItem = ({ activity }: ActivityItemProps) => {
	return renderActivityComponent(activity);
};
